import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { FleetPage, Notice } from '../../../../shared/sso-workspace/fleet-page'
import { useNotifyOpsAccess } from './access'
import { PageTrail } from '../../../../shared/sso-workspace/page-trail'
import { SECTION } from '../../../../shared/navigation/sections'
import './notify.scss'

export const TABS = [
  { to: '/admin/notify', label: 'Overview', exact: true },
  { to: '/admin/notify/deliveries', label: 'Delivery log' },
  { to: '/admin/notify/outbox', label: 'Outbox & events' },
  { to: '/admin/notify/dead-letter', label: 'Dead letter' },
  { to: '/admin/notify/captures', label: 'Captured payloads' },
  { to: '/admin/notify/rollout', label: 'Rollout' },
  { to: '/admin/notify/catalogue', label: 'Catalogue' },
  { to: '/admin/notify/credentials', label: 'Push credentials' },
  { to: '/admin/notify/test-send', label: 'Test send' }
]

// The section's frame: the title, its purpose, the tabs and, for someone
// who can only read, why nothing can be changed.
// The trail (audit F7): Notifications, then the tab other than Overview; a
// notification's timeline is opened from the delivery log, so it reads
// Notifications > Delivery log > Notification.
export const notifyTrail = pathname => {
  const path = String(pathname || '').replace(/\/+$/, '')
  if (path.startsWith('/admin/notify/timeline/')) {
    return [SECTION.notifications, { url: '/admin/notify/deliveries', text: 'Delivery log' }, { url: path, text: 'Notification' }]
  }
  const tab = TABS.find(t => !t.exact && (path === t.to || path.startsWith(`${t.to}/`)))
  return tab ? [SECTION.notifications, { url: tab.to, text: tab.label }] : [SECTION.notifications]
}

export const NotifyPage = ({ children }) => {
  const access = useNotifyOpsAccess()
  const { pathname } = useLocation()
  return (
    <FleetPage title="Notifications" purpose="Every notification the platform raises, where it went and what happened to it: inbox, email and push.">
      <PageTrail trail={notifyTrail(pathname)} />
      <nav className="sw-tabs" aria-label="Notifications">
        {TABS.map(t =>
          <NavLink key={t.to} to={t.to} exact={t.exact} activeClassName="active">{t.label}</NavLink>)}
      </nav>
      {access.reason && <Notice tone="warn" role="status">{access.reason}</Notice>}
      {children}
    </FleetPage>
  )
}
